import React from 'react';
import ModuleWrap from "../ModuleWrap/ModuleWrap";

const Production = (props) => {
    return (
        <ModuleWrap title="Produkcja" icon={props.icon}>
            Specjalizujemy się w produkcji palet pod indywidualne potrzeby klienta. Nasza oferta obejmuje typowe palety <span>EUR EPAL</span>, <span>1200 × 1000</span>, <span>1200 × 800</span>,
            oraz szeroki wybór palet wykonywanych według specyfikacji zamawiającego.
        </ModuleWrap>
    )
};

export default Production;


// WEBPACK FOOTER //
// ./src/components/Production/Production.js